import styled from "styled-components";

/**
 * Componente PaginationContainer
 *
 * Container principal a paginação desktop
 */
export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  width: fit-content;
  margin: 40px auto;
`;
